import React from 'react';
import { Typography, Grid, Card, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { toolTipBlue } from '../../color_utils';
import { trakrefFontFamily } from '../../utils';

const closeButton = { position: 'absolute', top: 0, right: 0, color: '#fff' };
const demoCard = { width: '20vw', bgcolor: toolTipBlue, borderRadius: '3%' };
const content = { fontSize: "14px", fontFamily: trakrefFontFamily, color: "#fff" };
const demoButtonText = { fontSize: "12px", fontFamily: trakrefFontFamily, color: "#fff", textDecoration: "underline" };

const DemoButton = ({
    primaryProps,
    text,
}) => (
    <Button
        {...primaryProps}
        id="Next"
        sx={{
            '&.MuiButton-root': {  fontFamily: trakrefFontFamily, padding: 0 },
            '&:focus': { outline: 'none' },
        }}
    >
        <Typography
            variant='paragraph'
            sx={demoButtonText}
        >
            {text}
        </Typography>
    </Button>
);

const DemoToolTip = ({
    step,
    isLastStep,
    primaryProps,
    closeProps,
    tooltipProps,
    skipProps,
    setDemo,
    // showDemoVideo,
}) => (
    <Card
        raised
        {...tooltipProps}
        sx={demoCard}
    >
        <Grid conatiner sx={{ margin: '3%', padding: '0.5vh 0.8vw 0vh' }}>
            <Grid item>
                <IconButton
                    aria-label="close"
                    onClick={(e) => {
                        skipProps.onClick(e);
                        localStorage.setItem("demoSeen", "true");
                        setDemo();
                    }}
                    sx={closeButton}
                >
                    <CloseIcon />
                </IconButton>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
                <Typography
                    variant='paragraph'
                    sx={content}
                >
                    {step.content1}
                </Typography>
            </Grid>
            {step.content2 && (
                <Grid item xs={12} md={12} lg={12}>
                    <Typography
                        variant='paragraph'
                        sx={content}
                    >
                        {step.content2}
                    </Typography>
                </Grid>
            )}
            <Grid item xs={12} md={12} lg={12} sx={{ marginTop: '1%' }}>
                {isLastStep ? (
                    <DemoButton
                        text="Close"
                        primaryProps={{
                            ...closeProps,
                            onClick: (_) => setDemo()
                        }}
                    />
                ) : (
                    <DemoButton
                        text="Next"
                        primaryProps={{ ...primaryProps }}
                    />
                )}
            </Grid>
        </Grid>
    </Card>
);


export default DemoToolTip;
